var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI/Glyphs/NOTAM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.70955495,4.23076923 C10.4119533,4.23076923 11,4.73092308 11,5.38015385 L11,5.38015385 L11,6.33476923 C11,6.98476923 10.4119533,7.61538462 9.70955495,7.61538462 L9.70955495,7.61538462 L5.51539698,7.61538462 C4.81316484,7.61538462 4.23076923,6.98476923 4.23076923,6.33476923 L4.23076923,6.33476923 L4.23076923,5.38015385 C4.23076923,4.73092308 4.81316484,4.23076923 5.51539698,4.23076923 L5.51539698,4.23076923 Z M2.9213388,0.846153846 L3.99504698,1.79734778 C4.26694421,2.03792322 4.30985408,2.16690929 4.09122535,2.38661473 L4.01775802,2.45545026 L2.90299526,3.44159864 L2.83294043,3.38669232 L2.82700062,2.60222799 C1.892878,2.65187567 1.14760642,3.33379666 1.14760642,4.17316731 C1.14760642,5.04486309 1.9484327,5.75338658 2.93304372,5.75338658 C3.2497754,5.75338658 3.50693428,5.98074513 3.50693428,6.26115401 C3.50693428,6.54156289 3.2497754,6.76923077 2.93304372,6.76923077 C1.31601753,6.76923077 0,5.60521685 0,4.17316731 C0,2.82980664 1.16084617,1.72939807 2.63952696,1.59792696 L2.81844031,1.58684779 L2.813374,0.899668172 L2.9213388,0.846153846 Z M9.83653846,5.38015385 C9.83653846,5.28738462 9.80994505,5.30769231 9.70955495,5.30769231 L9.70955495,5.30769231 L5.51539698,5.30769231 C5.41484066,5.30769231 5.22802198,5.28738462 5.22802198,5.38015385 L5.22802198,5.38015385 L5.22802198,6.33476923 C5.22802198,6.42753846 5.41484066,6.53846154 5.51539698,6.53846154 L5.51539698,6.53846154 L9.70955495,6.53846154 C9.80994505,6.53846154 9.83653846,6.42753846 9.83653846,6.33476923 L9.83653846,6.33476923 Z M9.70955495,4.4408921e-16 C10.3680534,4.4408921e-16 10.9260475,0.35739612 10.9932245,0.962626899 L11,1.08694505 L11,2.08701832 C11,2.72541117 10.4831621,3.3072836 9.83979893,3.37752393 L9.70955495,3.38461538 L5.51539698,3.38461538 C4.85705434,3.38461538 4.30403679,2.84264251 4.23748125,2.21380843 L4.23076923,2.08701832 L4.23076923,1.08694505 C4.23076923,0.449156593 4.74264037,0.0518986951 5.38524572,0.00473281894 L5.51539698,4.4408921e-16 L9.70955495,4.4408921e-16 Z M9.70955495,0.967032967 L5.51539698,0.967032967 C5.43160005,0.967032967 5.2878987,0.982926333 5.24232594,1.04437322 L5.22802198,1.08694505 L5.22802198,2.08701832 C5.22802198,2.1703213 5.36527652,2.35368259 5.4678162,2.40437147 L5.51539698,2.41758242 L9.70955495,2.41758242 C9.79560361,2.41758242 9.82743429,2.24612155 9.83477267,2.13593054 L9.83653846,2.08701832 L9.83653846,1.08694505 C9.83653846,0.989919414 9.80994505,0.967032967 9.70955495,0.967032967 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Table-Ribbon-Filters",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-Table->-Trackers",
    transform: "translate(-1252.000000, -3260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(1125.000000, 3125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Buttons/Text/Text---D-Copy",
    transform: "translate(127.500000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Glyphs/NOTAM",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#F9F9F9",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/UI/Slate/Slate-2",
    mask: "url(#mask-2)",
    fill: "#C5D2DE"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -2.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReOrder);
export default __webpack_public_path__ + "static/media/ReOrder.54d2811f292b83a0c8de3a8e956566f4.svg";
export { ForwardRef as ReactComponent };